var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIndicator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#2C3421;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M963.7,1051.1H116.3c-48.2,0-87.3-39.2-87.3-87.3V116.3c0-48.2,39.2-87.3,87.3-87.3h847.5 c48.2,0,87.3,39.2,87.3,87.3v847.5C1051.1,1011.9,1011.9,1051.1,963.7,1051.1z M116.3,48.9c-37.1,0-67.3,30.2-67.3,67.3v847.5 c0,37.1,30.2,67.3,67.3,67.3h847.5c37.1,0,67.3-30.2,67.3-67.3V116.3c0-37.1-30.2-67.3-67.3-67.3H116.3z M936.3,178.7 c-23.5,0-42.6,19.1-42.6,42.6c0,10.6,3.9,20.3,10.3,27.8L678.1,661.9c-2-0.3-3.9-0.4-6-0.4c-4,0-8,0.6-11.7,1.6L443.7,370.4 c4.3-6.7,6.8-14.6,6.8-23.1c0-23.5-19.1-42.6-42.6-42.6s-42.6,19.1-42.6,42.6c0,10.9,4.1,20.9,10.9,28.4L148.8,812.4 c-1.7-0.2-3.4-0.3-5.1-0.3c-23.5,0-42.6,19.1-42.6,42.6s19.1,42.6,42.6,42.6c23.5,0,42.6-19.1,42.6-42.6c0-10.9-4.1-20.9-10.9-28.4 l227.4-436.7c1.7,0.2,3.4,0.3,5.1,0.3c4,0,8-0.6,11.7-1.6l216.8,292.7c-4.3,6.7-6.8,14.6-6.8,23.1c0,23.5,19.1,42.6,42.6,42.6 s42.6-19.1,42.6-42.6c0-10.6-3.9-20.3-10.3-27.8l225.9-412.8c2,0.3,3.9,0.4,6,0.4c23.5,0,42.6-19.1,42.6-42.6 S959.8,178.7,936.3,178.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndicator);
export default __webpack_public_path__ + "static/media/indicator.76b8bba009462fa5e9aa28829df3e398.svg";
export { ForwardRef as ReactComponent };